import { createContext, useContext } from 'react'

export const FullScreenContext = createContext()

export function useSetFullScreen() {
  const setFullScreen = useContext(FullScreenContext)
  if (!setFullScreen) throw new Error('FullScreenContext value does not exist')
  return setFullScreen
}
